import { ErrorBoundary, JSXElement, Match, mergeProps, Switch } from 'solid-js';
import ContactSupport from '~/components/ErrorBoundaries/ContactSupport.tsx';
import { logErrorToSentry } from '~/utils/productLogging/sentry.ts';
import PortalLinkExpired, {
  ApiRequestFailedContext,
  LinkExpiredContext
} from '~/components/ErrorBoundaries/PortalLinkExpired.tsx';
import { isLoadedInIframe } from '~/utils/commonUtils.ts';
import { ERROR_CODES } from '~/api';

type AdminPortalErrorBoundaryProps = {
  children: JSXElement;
};

export default function AdminPortalErrorBoundary(
  props: AdminPortalErrorBoundaryProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <ErrorBoundary
      fallback={(err) => {
        console.error(err);
        logErrorToSentry(err);
        return (
          <Switch>
            <Match
              when={
                err instanceof Error && err.message === ERROR_CODES.UNAUTHORIZED
              }
            >
              <PortalLinkExpired
                context={
                  isLoadedInIframe()
                    ? LinkExpiredContext.EMBEDDED_ADMIN_PORTAL
                    : LinkExpiredContext.STANDALONE_ADMIN_PORTAL
                }
              />
            </Match>
            <Match
              when={err instanceof Error && err.message === ERROR_CODES.GENERIC}
            >
              <PortalLinkExpired
                context={
                  isLoadedInIframe()
                    ? ApiRequestFailedContext.EMBEDDED_PORTAL
                    : ApiRequestFailedContext.STANDALONE_PORTAL
                }
              />
            </Match>
            <Match when={true}>
              <ContactSupport showLogo={false} />;
            </Match>
          </Switch>
        );
      }}
    >
      {merged.children}
    </ErrorBoundary>
  );
}
